const EventBus = new BroadcastChannel("EventBus-getStoreName");
export default EventBus;
